"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var client_1 = require("@apollo/client");
var AcStampButton_1 = require("./AcStampButton");
var Stamp_1 = require("./Stamp");
exports.QUERY = client_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query AcSvgStampButtonMenuPropsQuery {\n    viewer {\n      id\n      faxStamps(page: 1, size: 1000) {\n        content {\n          id\n          faxStampId\n          type\n          imageUrl\n          imageName\n          text\n        }\n      }\n    }\n  }\n"], ["\n  query AcSvgStampButtonMenuPropsQuery {\n    viewer {\n      id\n      faxStamps(page: 1, size: 1000) {\n        content {\n          id\n          faxStampId\n          type\n          imageUrl\n          imageName\n          text\n        }\n      }\n    }\n  }\n"])));
exports.AcSvgStampButtons = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '100%' : _b, height = _a.height;
    var _c = client_1.useQuery(exports.QUERY), loading = _c.loading, data = _c.data, error = _c.error;
    var renderStamps = function () {
        var _a, _b;
        if (Array.isArray((_b = (_a = data === null || data === void 0 ? void 0 : data.viewer) === null || _a === void 0 ? void 0 : _a.faxStamps) === null || _b === void 0 ? void 0 : _b.content)) {
            return data.viewer.faxStamps.content.map(function (faxStamp, index) {
                var stamp = Stamp_1.Stamp.textboxStamp();
                var buttonWidth = 40;
                if (faxStamp.type === 'SVG') {
                    stamp = Stamp_1.Stamp.svgStamp(faxStamp.imageUrl);
                }
                else if (faxStamp.type === 'SET_PHRASE') {
                    stamp = Stamp_1.Stamp.setPhraseStamp(faxStamp.text);
                    buttonWidth = 200;
                }
                else if (faxStamp.type === 'date') {
                    stamp = Stamp_1.Stamp.dateStamp(faxStamp.options);
                    buttonWidth = 200;
                }
                return (react_1.default.createElement(AcStampButton_1.AcStampButton, { key: index, stamp: stamp, label: faxStamp.imageName, size: "stamp_sm", width: buttonWidth, height: buttonWidth }));
            });
        }
        return null;
    };
    return renderStamps();
};
exports.AcSvgStampButtons.displayName = 'AcSvgStampButtons';
var templateObject_1;
//# sourceMappingURL=AcSvgStampButtons.js.map